import { BANNER_TYPES, DSBanner } from '@elliemae/ds-banner';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoanDataField } from '../../../../common/utils/selectors';
import { searchFormActions } from '../../../../store/searchForm';
import { useSearchFormSelector } from '../../../components/Form/utils/customHooks';

const fieldLabelMap: Record<string, string> = {
  PropertyValue: 'Property Value',
  LienPosition: 'Lien Position',
  LoanPurpose: 'Loan Purpose',
};

const helocFieldLabelMap: Record<string, string> = {
  ...fieldLabelMap,
  FirstMortgageAmount: 'Loan Amount (Initial Draw)',
};

const defaultFieldLabelMap: Record<string, string> = {
  ...fieldLabelMap,
  FirstMortgageAmount: 'Loan Amount',
};

const replaceFieldNames = (message: string, isHELOC: boolean): string => {
  const map = isHELOC ? helocFieldLabelMap : defaultFieldLabelMap;
  return Object.entries(map).reduce(
    (msg, [raw, label]) => msg.replace(raw, label),
    message,
  );
};

export const ErrorBanner = ({ body }: { body?: string } = {}) => {
  const dispatch = useDispatch();
  const bannerIsOpen = (useSearchFormSelector('errorForm.bannerIsOpen') as any)
    ?.value;
  let bannerBody = body || 'Please fix any fields that are marked below.';
  const errorFilters = (useSearchFormSelector('errorForm.errorFilters') as any)
    ?.value;
  const errorFields = (useSearchFormSelector('errorForm.errorFields') as any)
    ?.value;
  const loanType = useSelector(selectLoanDataField('loanType'));
  if (!body && errorFilters.length > 0 && errorFields.length === 0) {
    bannerBody = replaceFieldNames(
      errorFilters?.[0]?.details ?? '',
      loanType === 'HELOC',
    );
  }

  return (
    <DSBanner
      containerProps={{ 'data-public': '' }}
      body={bannerBody}
      isOpen={!!bannerIsOpen}
      onClose={
        (() => dispatch(searchFormActions.setBannerIsOpen(false))) as any
      }
      label="Errors Found"
      type={BANNER_TYPES.DANGER}
    />
  );
};
